/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {
  makeStyles,
  Step,
  StepConnector,
  StepIconProps,
  StepLabel,
  Stepper,
  withStyles
} from '@material-ui/core';
import clsx from 'clsx';
import {GenericObject} from '@ion/core/src/types/entities';
import {dlsColor} from '@ion/dls/src/theme/theme';
import {isCurrentTheme} from '@ion/dls/src/theme/useThemeContext';
import {DLSTheme} from '@ion/dls/src/types/types';
import TiltSensorHistoryItem from './TiltSensorHistoryItem';

export interface TiltSensorEventStepperProps {
  tiltData: GenericObject[];
  isOverThreshold?: boolean;
}

const useStyles = makeStyles((theme: DLSTheme) => {
  return {
    stepper : {
      width   : '100%',
      padding : '0px'
    },
    historyIconCircle : {
      width           : 8,
      height          : 8,
      borderRadius    : '50%',
      backgroundColor : 'currentcolor'
    },
    historyIconRoot : {
      color : dlsColor('grey3')
    },
    historyIconAlert : {
      color : dlsColor('caRed')
    },
    historyIconNormal : {
      color : dlsColor('caBlue')
    }
  };
});

const TiltSensorStepConnector = withStyles(theme => ({
  vertical : {
    marginLeft : 3,
    padding    : 0
  },
  lineVertical : {
    minHeight : 10
  }
}))(StepConnector);

const TiltSensorEventStepper = ({tiltData, isOverThreshold}: TiltSensorEventStepperProps) => {
  const classes   = useStyles();
  const isCurrent = isCurrentTheme();
  const threshold = tiltData?.[0]?.settings?.maxTip;

  const TiltSensorStepIcon = function({active}: StepIconProps) {
    return (
      <div className={clsx(
        classes.historyIconRoot, {
          [isOverThreshold ? classes.historyIconAlert : classes.historyIconNormal] : active
        })}>
        <div className={classes.historyIconCircle} />
      </div>
    );
  };

  return (
    <div className={classes.stepper}>
      <Stepper style={{padding: isCurrent ? 0 : '0 0 15px 15px'}}
        connector={<TiltSensorStepConnector />}
        orientation='vertical'
        activeStep={0}>
        {tiltData.map((item, index) => (
          <Step key={index}>
            <StepLabel StepIconComponent={TiltSensorStepIcon}>
              <TiltSensorHistoryItem item={item}
                index={index}
                maxTip={threshold} />
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </div>
  );
};

export default TiltSensorEventStepper;
